export default "__VITE_ASSET__BxopMOqc__"